export default "__VITE_ASSET__61b13143__"